<template>
  <v-list class="org-list">
    <v-list-item
      :class="['org-list-item', {dense: isMobile}, {'org-active': !currentSelectedOrg.id}]"
      @click="selectAllOrgs"
    >
      <img
        :src="NoiseAwareLogo"
        height="40"
        width="40"
        alt="NoiseAware"
      >
      <v-list-item-content
        class="org-list-item__content"
        v-text="'All Organizations'"
      />
    </v-list-item>
    <v-list-item
      v-for="(item, i) in organizations"
      :key="i"
      :class="['org-list-item', {dense: isMobile}, {'org-active': item.active}]"
      @click="selectOrg(item.org)"
    >
      <v-badge
        dot
        :value="item.badge"
        color="error"
        offset-x="0"
        offset-y="4"
      >
        <v-img
          v-if="item.image"
          :src="item.image"
          height="40"
          width="40"
        />
        <div
          v-else
          class="org-image-placeholder"
          v-text="item.text[0]"
        />
      </v-badge>
      <v-list-item-content
        class="org-list-item__content"
        v-text="item.text"
      />
    </v-list-item>
  </v-list>
</template>

<script>
  import NoiseAwareLogo from '@/assets/NoiseAware_Logo_Bug_Cream.svg'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrgList',
    data: function () {
      return {
        NoiseAwareLogo,
      }
    },
    computed: {
      ...mapGetters({
        currentUserOrgs: 'Users/currentUserOrgs',
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        hasBillingEnabled: 'Billing/orgBillingEnabled',
        hasBillingIssue: 'Billing/orgHasBillingIssue',
      }),
      organizations () {
        return this.currentUserOrgs.map(org => ({
          text: org.name,
          image: '',
          badge: this.hasBillingEnabled(org.id) && this.hasBillingIssue(org.id),
          active: this.currentSelectedOrg.id === org.id,
          org,
        }))
      },
      isMobile () {
        return this.$vuetify.breakpoint.mobile
      },
    },
    methods: {
      selectOrg (org) {
        this.$store.commit('Organizations/setSelectedOrg', org)
      },
      selectAllOrgs () {
        this.$store.commit('Organizations/setSelectedOrg', { id: null })
      },
    },
  }
</script>

<style lang="scss">
  @mixin white-lato {
    font-family: 'Lato', sans-serif;
    font-weight: 600;
    color: white;
    text-transform: uppercase;
  }
  .org-list {
    padding-top: 0;
    & .org-list-item {
      min-height: 80px;
      &:hover {
        background-color: $nav-highlight;
      }
      & .org-list-item__content {
        color: white !important;
        font-family: 'Degular', sans-serif;
        font-size: 14px;
        margin-left: 18px;
      }
      &.org-active {
        background-color: $muted;
      }
      &.dense {
        min-height: 58px;
        font-size: 13px;
        border-radius: 5px;
        &:hover {
          background-color: $nav-highlight;
        }
        & .org-list-item__content {
          @include white-lato();
          font-size: 13px;
          margin-left: 18px;
          letter-spacing: 1px;
        }
        &.org-active {
          background-color: $nav-highlight;
        }
        & + .org-list-item.dense {
          margin-top: 10px;
        }
      }
    }
    & .org-image-placeholder {
      @include white-lato();
      font-size: 26px;
      opacity: 0.28;
      border: 2px solid white;
      border-radius: 100px;
      height: 40px;
      width: 40px;
      text-align: center;
      line-height: 26px;
      padding: 4px 0;
    }
  }
</style>
